import KendoDataSourceBase from '../KendoDataSourceBase'

export default {
    mixins: [
        KendoDataSourceBase
    ],
    mounted () {
        this.kendoDataSource = new kendo.data.DataSource(this.widgetOptions)
    },
    methods: {
        kendoWidget() {
            return this.kendoDataSource || new kendo.data.DataSource(this.widgetOptions)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSource/KendoDataSourceMixin.js